<template>
    <!-- Modal -->
    <div class="modal fade" id="discussionModal" tabindex="-1" aria-labelledby="discussionModalLabel" aria-hidden="true" >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="discussionModalLabel">Thread</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">×</button>
                </div>
                <div class="">

                    <div class=" rounded border-0  card">
                        <div class="card-body">
                            <ul class="media-list list-unstyled mb-0">
                                <discuss_question_comment :comment="localItem" ></discuss_question_comment>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";
import Discuss_question_comment from "../question_sessions/discuss_question_comment.vue";

const toast = useToast();

export default {
    components: {Discuss_question_comment},
    data() {
        return {
            localItem: []
        }
    },
    props: {
        discussion: {
            required: true
        }
    },
    watch: {
        'discussion': function (newVal) {
            if (newVal) {
                this.localItem = newVal;
                // this.showDialog();
                // this.openModal();
                // this.created();
                this.updateItem();
            }
        },
    },
    created() {
        // this.getItem();
    },
    methods: {
        // showDialog() {
        //     const confirmationModal = new bootstrap.Modal(document.getElementById('discussionModal'));
        //     confirmationModal.show();
        //
        //     var firstDivContent = document.getElementById('discussionModal');
        //     var secondDivContent = document.getElementById('modal-codes');
        //     secondDivContent.innerHTML = firstDivContent.innerHTML;
        //     firstDivContent.remove();
        // },
        updateItem() {
            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get(`question_discussions/${this.discussion.id}`, {
                params: {
                    'subscribe_id': this.$route?.params?.subscribe_id
                }
            }).then(response => {
                // this.item = response.data.data;
                this.localItem = response.data.data;

                toast.dismiss(id);
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });
        },
        // openModal() {
        //     const modal = new bootstrap.Modal(document.getElementById('discussionModal'));
        //     console.log(modal);
        //     modal.show();
        // }
    }
}
</script>
